import Vue from '../plugins/vueFactory';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import productSearch from './productSearch';
import registrationForm from './registrationForm';
import serviceForm from './serviceForm';
import translations from './translations';
import webshop from './webshop';
import spareParts from './spareParts';

Vue.use(Vuex);

const state = {
  culture: undefined,
  isAuthenticated: undefined
};

const mutations = {
  setCulture(state, culture) {
    state.culture = culture;
  },
  setIsAuthenticated(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  }
};

const getters = {
  activeCulture(state) {
    return state.culture;
  }
};

if (!window.vuexStore) {
  const vuexLocal = new VuexPersistence({
    reducer: (state) => ({
      webshop: {
        numberOfItemsInShoppingCart: state.webshop.numberOfItemsInShoppingCart,
        shoppingCartLastRefreshedTimestamp:
          state.webshop.shoppingCartLastRefreshedTimestamp
      }
    }),
    filter: (mutation) =>
      mutation.type === 'webshop/setShoppingCart' ||
      mutation.type === 'webshop/resetShoppingCart'
  });

  window.vuexStore = new Vuex.Store({
    modules: {
      productSearch,
      registrationForm,
      serviceForm,
      translations,
      webshop,
      spareParts
    },
    state,
    mutations,
    getters,
    strict: process.env.NODE_ENV !== 'production',
    plugins: [vuexLocal.plugin]
  });
}

export default window.vuexStore;
